import * as React from 'react';
import { Link } from "react-router-dom";
import Button from '@mui/joy/Button';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import Stack from '@mui/joy/Stack';

 const GiveModal = (data) => {
    const [open, setOpen] = React.useState(false);
    const text = data.text;
    const linkClass = data.linkClass

    return (
        <React.Fragment>
            <Link
                            className={linkClass}
                            onClick={() => setOpen(true)}
                            to="#"
                        >
                            {text}
            </Link>
            <Modal open={open} onClose={() => setOpen(false)}>
                <ModalDialog sx={{ backgroundColor: '#d7d9db', borderColor: '#000000'}}>
                    <DialogTitle sx={{justifyContent: 'center'}}>Ways to support NHV</DialogTitle>
                    <DialogContent></DialogContent>
                        <Stack spacing={2}>
                        <DialogContent>Give via Realm:</DialogContent>
                        <Link to="https://onrealm.org/nhvineyard/give/now" target='_blank' rel='noopener'><Button sx={{ minWidth:'20.625rem',padding:'0.2rem', height:'3.625rem', fontWeight:'bold', fontFamily:'"HelveticaNeue",Arial,sans-serif', fontSize:'1rem' }}>Give</Button></Link>
                        <DialogContent>Give via PayPal:</DialogContent>
                        <form action="https://www.paypal.com/ncp/payment/3EBSAFR7WTMG6" method="post" target="_blank"
                            style={{display:'inline-grid', justifyItems:'center', alignContent:'start', gap:'0.5rem'}}>

                            <input class="pp-3EBSAFR7WTMG6" type="submit" value="Give" style={{textAlign:'center', border:'none', borderRadius:'0.25rem', minWidth:'20.625rem', 
                            padding:'0.2rem', height:'3.625rem', fontWeight:'bold', backgroundColor:'#FFD140', color:'#000000', fontFamily:'"HelveticaNeue",Arial,sans-serif', fontSize:'1rem', 
                            lineHeight:'1.25rem', cursor:'pointer'}} /> 
                            <img src='https://www.paypalobjects.com/images/Debit_Credit.svg' alt="cards" />
                            <section> Powered by <img
                            src="https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-wordmark-color.svg" alt="paypal"
                            style={{height:'0.875rem', verticalAlign:'middle'}}/>
                            </section>
                        </form>
                        </Stack>
                </ModalDialog>
            </Modal>
        </React.Fragment>
    );
}

export default GiveModal;